module.exports = __webpack_public_path__ + "static/media/contact-background-mobile.27f2dde3.png";